<template>
  <div class="dashboard-editor-container">

    <el-row
      type="flex"
      justify="space-between"
      style="background:#fff; padding:16px 0 0 0; margin-bottom:32px;"
    >
     <el-col :span="6" v-for="(item,index) in cardData" :key="index" style="padding: 0;">
        <CoreCard :cardInfo="item"/>
      </el-col>
    </el-row>

    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
        <el-col :xs="24" :sm="24" :lg="24">
          <BarChart
              :chart-data="barChartData"
              :chart-info="{ title: '当日工厂生产进度统计' }"
            />
        </el-col>
            <!-- <el-col :xs="24" :sm="12" :lg="12">
          <BarChart
              :chart-data="barChartData"
              :chart-info="{ title: '当日工厂发货进度统计' }"
            />
        </el-col> -->
      </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="{
            xAxis: ['1月', '2月', '3月', '4月', '5月','6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            series: [
              { name: '小袋码采集率', data: [120, 200, 150, 300, 280,120, 200, 150, 300, 280,150,250] },
              { name: '大袋码采集率', data: [100, 250, 120, 310, 240,100, 150, 170, 320, 230,110,255] },
              { name: '码垛工位采集率', data: [90, 170, 190, 250, 270,120, 200, 150, 300, 280,130,230] }
            ]
          }"
          :chart-info="{ title: '生产节拍监控' }"
        />
      </el-col>
    </el-row>
       <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="{
            xAxis: ['1月', '2月', '3月', '4月', '5月','6月', '7月', '8月', '9月', '10月', '11月', '12月'],
            series: [
              { name: '小袋码采集率', data: [120, 200, 150, 300, 280,120, 200, 150, 300, 280,150,250] },
              { name: '大袋码采集率', data: [100, 250, 120, 310, 240,100, 150, 170, 320, 230,110,255] },
              { name: '码垛工位采集率', data: [90, 170, 190, 250, 270,120, 200, 150, 300, 280,130,230] }
            ]
          }"
          :chart-info="{ title: '采集率状态' }"
        />
      </el-col>
    </el-row>

    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <ProductionList />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ProductionList from "./productionList.vue";
import CoreCard  from"../components/CoreCard.vue";
import LineChart  from"../components/LineChart.vue";
import BarChart from '../components/BarChart.vue';import { workCountCurDay,workPlanCountCurDay,factoryWorkOutCountCurDay } from "@/api/board";
export default {
  name: "ProductionMonitoring",
  components: {
    CoreCard,
    LineChart,
    BarChart,
    ProductionList
  },
  data() {
    return {
    cardData:[
          {
            titleOne:"计划产量",
            numOne:0,
            titleTwo:"实际产量",
            numTwo:0,
            ratioLabel:"完成率"
          },
          {
            titleOne:"生产线OEE（设备综合效率）",
            numOne:0,
            marginTop:'0%'
          },
          {
            titleOne:"小袋码采集成功率",
            numOne:0,
            marginTop:'0%'
          },
          {
            titleOne:"大袋码采集成功率",
            numOne:10,
            marginTop:'0%'
          },
      ],
      lineChartInfo:{
        title:"折线图1"
      },

      barChartKey: 0, // BarChart 组件刷新标记（初始值 0）
      barChartData: {
        xAxis: ["工厂一", "工厂二", "工厂三", "工厂四", "工厂五", "工厂六"],
        series: [
          { name: "计划产量", data: [0, 0, 0, 0, 0, 0] },
          { name: "实际产量", data: [0, 0, 0, 0, 0, 0]},

        ]
      }
    };
  },


  mounted() {
    this.getWorkCountCurDay();
    this.getWorkPlanCountCurDay();
    this.getFactoryWorkOutCountCurDay();
  },
  methods: {

    //获取今日产量
    getWorkCountCurDay(){
     workCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numOne = response.data;
        }
      });
    },
        //获取今日计划产量
    getWorkPlanCountCurDay(){
     workPlanCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numTwo = response.data;
        }
      });
    },

    //当日工厂生产、发货进度
    getFactoryWorkOutCountCurDay(){
     factoryWorkOutCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null) {
          const factories = []; // x轴工厂名称
          const workPlanData = []; // 生产计划数据
          const workActualData = []; // 实际生产数据
                
          response.data.forEach(item => {
            factories.push(item.factory); // 工厂名称
            workPlanData.push(item.workPlanCountCurDay || 0); // 计划产量（兜底0）
            workActualData.push(item.workCountCurDay || 0); // 实际产量
          });
      
          // 2. 响应式更新 barChartData 和 barChartData2（整体替换数组，Vue 能检测到变化）
          this.barChartData = {
            ...this.barChartData, // 保留原有其他配置（如样式）
            xAxis: factories, // 替换 x轴数组
            series: [
              { ...this.barChartData.series[0], data: workPlanData }, // 替换计划产量数据
              { ...this.barChartData.series[1], data: workActualData } // 替换实际产量数据
            ]
          };
          
          // 3. 关键：更新 key，强制 BarChart 组件重新渲染（数据变化立即刷新）
          this.barChartKey += 1;
        
          console.log("折线图数据",response.data);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
